import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  carousel: icon('ic_carousel'),
  galery: icon('ic_galery'),
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  food_book: icon('ic_food_menu'),
  reservation: icon('ic_reservation'),
  dish: icon('ic_dish'),
  menu_type: icon('ic_menu_type'),
  event: icon('ic_event'),
  dish_list: icon('ic_dishlist')
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: t('Gestão'),
        items: [
          // USER
          {
            title: t('Menus'),
            path: paths.dashboard.ementas.list,
            icon: ICONS.food_book,
          },
          {
            title: t('Reservas'),
            path: paths.dashboard.reservas,
            icon: ICONS.reservation,
          },
          {
            title: t('Horários'),
            path: paths.dashboard.horarios,
            icon: ICONS.calendar,
          },
          {
            title: t('Slider'),
            path: paths.dashboard.carousel,
            icon: ICONS.carousel
          },
          {
            title: t('Galeria'),
            path: paths.dashboard.galeria,
            icon: ICONS.galery
          },
        ],
      },
      {
        subheader: t('Parameterizações'),
        items: [
          // USER
          {
            title: t('Tipo Menus'),
            path: paths.dashboard.param.menu_type,
            icon: ICONS.menu_type
          },
          {
            title: t('Categoria Pratos'),
            path: paths.dashboard.param.dish_category,
            icon: ICONS.dish
          },
          {
            title: t('Lista de Pratos'),
            path: paths.dashboard.param.dish_list,
            icon: ICONS.dish_list
          },
          {
            title: t('Alergénios'),
            path: paths.dashboard.param.allergen,
            icon: ICONS.label
          },
        ],
      },
      {
        subheader: t('Administração'),
        items: [
          {
            title: t('Utilizadores'),
            path: paths.dashboard.users,
            icon: ICONS.user
          },
        ],
      }
      
    ],
    [t]
  );

  return data;
}
